import { zeroedUUID } from "./constants";
export function getRandomOrZeroedUUID() {
  let uuid = zeroedUUID;
  if (!window.crypto?.randomUUID) {
    console.warn(
      "Crypto not available, Analytics visitUUID will be zeroed. Serve application over https."
    );
    return uuid;
  }
  uuid = window.crypto.randomUUID();
  return uuid;
}
